import { HModules, HCF, HLink, HLocalStorage } from "@macashipo/mlib"
import Xmas from "./xmas2023/theme3"
import Tet from "./tet2024/theme"
import QK from "./qk2025/theme"
import HW from "./ghost25/theme"
import { KConfigApp, KLocalStorage } from "src/helpers/K"
const ModuleThemes = {
  _key: "themes",
  _fnList: {},
  _config: {},
  runAfterInit: HConfig => {
    HModules.initDefault(ModuleThemes, {})
    let _theme = HLocalStorage.getString(KLocalStorage.themeSeason)
    if (_theme == "xmas2023") {
      Xmas.init()
    } else if (_theme == "tet2024") {
      Tet.init()
    } else if (_theme == "qk2025") {
      QK.init()
    } else if (_theme == "hw2025") {
      HW.init()
    } else {
      //force theme in days
      // if (
      //   document.location.href.indexOf("app.allianceitsc.com") > -1 ||
      //   document.location.href.indexOf("app-dev.allianceitsc.com") > -1 ||
      //   document.location.href.indexOf("localhost") > -1
      // ) {
      //   let _now = new Date().getTime()
      //   if (_now > 1761843600000 && _now < 1761930000000) {
      //     HW.init()
      //   }
      // }
    }
  },
}

export default ModuleThemes
